'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    DeviceStatusController.$inject = ['$interval', '$q', '$stateParams', '$translate', 'analyticsService', 'appConfig', 'iotService', 'measurementsService'];
    angular.module('app.admin').component('deviceStatus', {
        require: { app: '^app' },
        template: '<style>\n    .latest-values {\n        display: inline-block;\n    }\n\n    .latest-values .label.label-default {\n        color: #333;\n        background: transparent;\n    }\n\n    .alerts-count {\n        width: 50px;\n        display: inline-block;\n        text-align: right;\n    }\n</style><div style="padding: 2em 0em;" translate-namespace="admin.device-status"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label | translate}}</a></li><li><a ui-sref="iot" translate-namespace="iot" translate>.Urban environment monitoring</a></li><li translate-namespace="iot"><a ui-sref="iot-status" translate>.Infrastructure management</a></li><li ng-init="gateway_name_attr = (\'gateway.name\' | translate)" class="active">{{$ctrl.gateway[gateway_name_attr]}}</li><li class="active">{{$ctrl.device[device_name_attr]}}</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="page-header" ng-init="device_name_attr = (\'device.name\' | translate)"><h2>{{$ctrl.device[device_name_attr]}} <small><span ng-if="$ctrl.deviceStatus.online" class="label label-success" translate>.Online</span> <span ng-if="!$ctrl.deviceStatus.online" class="label label-danger" translate>.Offline</span></small></h2></div><div class="row"><div class="col-lg-3"><h3 translate>.Sensors</h3><ul class="list-group" ng-init="modality_name_attr = (\'modality.name\' | translate)"><li class="list-group-item" ng-repeat="modality in $ctrl.deviceModalities | orderBy: modality_name_attr"><span class="modality">{{modality[modality_name_attr]}}</span><div class="pull-right"><div class="latest-values"><span ng-switch="modality.slug" ng-if="$ctrl.latestValues[modality.id].value" class="label label-default"><span ng-switch-when="wind-direction">{{$ctrl.latestValues[modality.id].value | toCompass:$ctrl.compass:\'-\'}} <i ng-if="$ctrl.latestValues[modality.id].value" class="fa fa-long-arrow-up" style="transform:rotate({{$ctrl.latestValues[modality.id].value | toDirection}}deg)" aria-hidden="true"></i></span> <span ng-switch-when="wind-speed">{{$ctrl.latestValues[modality.id].value | number: 1}} {{modality.unit}} - {{$ctrl.latestValues[modality.id].value | toBeaufort: true}} Bf</span> <span ng-switch-default>{{$ctrl.latestValues[modality.id].value | number: 1}} {{modality.unit}}</span></span> <span ng-if="!$ctrl.latestValues[modality.id].value">---</span></div><div class="alerts-count"><span class="label label-warning" ng-if="$ctrl.alertsCount[modality.id]" title="{{$ctrl.alertsCount[modality.id] | number}} alerts today"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{$ctrl.alertsCount[modality.id] | number}}</span></div></div></li></ul></div><div class="col-lg-9"><h3 translate>.Latest values</h3><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" ng-repeat="modality in $ctrl.deviceModalities | orderBy: modality_name_attr"><div class="panel panel-default" ng-init="modality_name_attr = (\'modality.name\' | translate)"><div class="panel-heading">{{modality[modality_name_attr]}} - {{modality.unit}}</div><div class="panel-body" style="padding:0;"><nvd3 id="{{modality.slug}}" options="$ctrl.uiConfig.lineChart.options" config="$ctrl.uiConfig.lineChart.config" data="$ctrl.charts[modality.id].data"></nvd3></div></div></div></div></div></div></div>',
        controller: DeviceStatusController,
        controllerAs: '$ctrl',
        bindings: {
            device: '='
        }
    });

    function DeviceStatusController($interval, $q, $stateParams, $translate, analyticsService, appConfig, iotService, measurementsService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {
            $ctrl.googleMapsConfig = appConfig.googleMaps;

            $ctrl.uiConfig = new UiConfig(measurementsService);
            $ctrl.charts = {};

            $q.all({
                status: iotService.getDeviceWithStatus($stateParams.id),
                modalities: iotService.getModalities(true),
                gateway: iotService.getDeviceGateway($ctrl.device.id),
                alertLevels: analyticsService.getAlertLevels(),
                translations: getTranslations()
            }).then(function (r) {
                $ctrl.deviceStatus = r.status;
                $ctrl.gateway = r.gateway;
                $ctrl.deviceModalities = _.filter(r.modalities, _.conforms({ id: _.partial(_.includes, $ctrl.device.modality_ids) }));
                $ctrl.modalities = r.modalities;

                $ctrl.uiConfig.lineChart.initialize(r.alertLevels);

                // $ctrl.mapCenter = `${$ctrl.device.latitude || '35.3160385'},${$ctrl.device.longitude || '25.0762965'}`;

                $ctrl.deviceModalities.forEach(function (modality) {
                    $ctrl.charts[modality.id] = { modality: modality, data: [] };
                });

                setTranslations(r.translations);
                $ctrl.uiConfig.lineChart.setTranslations(r.translations);

                updateCharts();
                $ctrl.updater = $interval(updateCharts, 300000, 100);
            }).catch(function (error) {
                if (error.status === 401) {
                    $state.go('login');
                }
                console.error(error);
            });;
        };

        function getTimeRange() {
            var from, to;

            to = moment();
            to.add(-to.minute() % 15, 'minute').startOf('minute');
            from = to.clone().add(-6, 'hour').startOf('minute');

            return { from: from, to: to };
        }

        $ctrl.$onDestroy = function () {
            $interval.cancel($ctrl.updater);
        };

        function updateCharts() {

            var range = getTimeRange();

            /** Get latest values */
            getLatestValues($ctrl.device, range.from, range.to);

            $ctrl.deviceModalities.forEach(function (modality) {

                /** Clear old values */
                $ctrl.charts[modality.id].data = [];

                /** Get graph data, measurements and analytics */
                getMeasurements(modality, $ctrl.device, range.from, range.to);
                getAnalytics(modality, $ctrl.device, range.from, range.to);
            });
        }

        function getLatestValues(device, from, to) {
            $q.all({
                latestValues: measurementsService.getLatestDeviceMeasurements([device]),
                alertsCount: analyticsService.getDeviceAlertsCount(device.id, from, to)
            }).then(function (r) {
                $ctrl.latestValues = _.keyBy(r.latestValues, 'modality_id');
                $ctrl.alertsCount = r.alertsCount;
            }).catch(function (error) {
                if (error.status === 401) {
                    $state.go('login');
                }
                console.error('Oops, something went wrong!', error);
            });
        }

        function getMeasurements(modality, device, from, to) {
            measurementsService.getDeviceRecords(modality, device, from, to, '15 minute', true, false).then(function (r) {
                $ctrl.charts[r.modality.id].data.push({
                    id: 'measurements',
                    type: 'line',
                    yAxis: 1,
                    key: r.modality.name,
                    min: r.min,
                    max: r.max,
                    color: '#1E88E5',
                    values: r.measurements
                });
            }).catch(function (error) {
                if (error.status === 401) {
                    $state.go('login');
                }
                console.error('Oops, something went wrong!', error);
            });
        }

        function getAnalytics(modality, device, from, to) {
            analyticsService.getDeviceAlerts(modality, device, from, to).then(function (r) {

                $ctrl.charts[r.modality.id].data.push({
                    id: 'analytics',
                    key: 'Alerts',
                    type: 'scatter',
                    values: r.alerts,
                    color: '#E65100',
                    yAxis: 2
                });
            }).catch(function (error) {
                if (error.status === 401) {
                    $state.go('login');
                }
                console.error('Oops, something went wrong!', error);
            });
        }

        /**
         * 
         */
        function getTranslations() {
            return $translate(['admin.alert.description', 'compass.N', 'compass.NNE', 'compass.NE', 'compass.ENE', 'compass.E', 'compass.ESE', 'compass.SE', 'compass.SSE', 'compass.S', 'compass.SSW', 'compass.SW', 'compass.WSW', 'compass.W', 'compass.WNW', 'compass.NW', 'compass.NNW']);
        }

        function setTranslations(i18n) {
            $ctrl.compass = [i18n['compass.N'], i18n['compass.NNE'], i18n['compass.NE'], i18n['compass.ENE'], i18n['compass.E'], i18n['compass.ESE'], i18n['compass.SE'], i18n['compass.SSE'], i18n['compass.S'], i18n['compass.SSW'], i18n['compass.SW'], i18n['compass.WSW'], i18n['compass.W'], i18n['compass.WNW'], i18n['compass.NW'], i18n['compass.NNW']];
        }
    }

    var UiConfig = function () {
        function UiConfig(measurementsService) {
            _classCallCheck(this, UiConfig);

            this.lineChart = new MultiChartConfig(measurementsService);
        }

        _createClass(UiConfig, [{
            key: 'setTranslations',
            value: function setTranslations(i18n) {}
        }]);

        return UiConfig;
    }();

    /**
     * 
     */


    var MultiChartConfig = function () {
        function MultiChartConfig(measurementsService) {
            _classCallCheck(this, MultiChartConfig);

            this.toBeaufort = measurementsService.toBeaufort;
            this.toCompass = measurementsService.toCompass;

            this.config = {
                deepWatchOptions: true,
                deepWatchData: true,
                deepWatchDataDepth: 1
            };

            this.options = {
                title: { enable: false },
                subtitle: { enable: false },

                chart: {

                    id: 'linePlusScatterPlotChart',
                    type: 'linePlusScatterPlotChart',
                    useInteractiveGuideline: true,
                    showLegend: false,

                    height: 220,
                    duration: 250,

                    margin: { top: 30, right: 30, bottom: 50, left: 60 },

                    x: function x(d) {
                        return d.at;
                    },
                    y: this.getY(),

                    xAxis: {
                        tickFormat: this.timeFormatter(),
                        tickPadding: 20
                    },

                    yAxis1: {
                        tickFormat: d3.format(',.2f'),
                        showMaxMin: true,
                        tickPadding: 10
                    },

                    yAxis2: {
                        showMaxMin: false,
                        tickValues: [],
                        tickPadding: 10
                        // tickFormat: d => this.alertLevels[d].description,
                    },
                    yDomain2: [0, 9],

                    interactiveLayer: {
                        tooltip: {
                            headerFormatter: this.tooltipHeaderFormatter(),
                            valueFormatter: this.tooltipValueFormatter()
                        }
                    }
                }
            };
        }

        _createClass(MultiChartConfig, [{
            key: 'initialize',
            value: function initialize(alertLevels) {
                this.alertLevels = _.keyBy(alertLevels, 'order');
            }

            // getIsDefined() {
            //     var self = this;
            //     return function (d) {
            //         return (self.form.modality.slug === 'wind-direction' && typeof d.dir != 'undefined') ||
            //             (typeof d.avg != 'undefined') ||
            //             (d.hasOwnProperty('alerts'));
            //     }
            // }

        }, {
            key: 'getY',
            value: function getY() {
                var self = this;
                return function (d) {
                    if (d.hasOwnProperty('avg')) {
                        // if (self.form.modality.slug == 'wind-direction') {
                        //     return d.dir;
                        // }
                        return d.avg;
                    } else if (d.hasOwnProperty('alert')) {
                        return _.get(d, 'alert.order', undefined);
                        // switch (self.form.mode) {
                        //     case 'alerts':
                        return _.get(d, 'alert.order', undefined);
                        //     case 'groups':
                        //         return _.get(d, 'alert.group.order', undefined);
                        // }
                    }

                    return undefined;
                };
            }
        }, {
            key: 'setTranslations',
            value: function setTranslations(i18n) {
                this.alertDescription = i18n['admin.alert.description'];
                this.compass = [i18n['compass.N'], i18n['compass.NNE'], i18n['compass.NE'], i18n['compass.ENE'], i18n['compass.E'], i18n['compass.ESE'], i18n['compass.SE'], i18n['compass.SSE'], i18n['compass.S'], i18n['compass.SSW'], i18n['compass.SW'], i18n['compass.WSW'], i18n['compass.W'], i18n['compass.WNW'], i18n['compass.NW'], i18n['compass.NNW']];
            }
        }, {
            key: 'timeFormatter',
            value: function timeFormatter() {
                return function (d) {
                    return d3.currentLocale.timeFormat.multi([['%H:%M', function (d) {
                        return d.getHours();
                    }], ['%a %d', function (d) {
                        return d.getDay() && d.getDate() != 1;
                    }], ['%d %b', function (d) {
                        return d.getDate() != 1;
                    }], ['%B', function (d) {
                        return d.getMonth();
                    }], ['%Y', function (d) {
                        return true;
                    }]])(new Date(d));
                };

                // return d3.time.format('%H:%M');
                // return d3.currentLocale.timeFormat.multi([
                //     ['%H:%M', (d) => d.getHours()],
                //     ['%a %d', (d) => d.getDay() && d.getDate() != 1],
                //     ['%d %b', (d) => d.getDate() != 1],
                //     ['%B', (d) => d.getMonth()],
                //     ['%Y', (d) => true],
                // ]);
            }
        }, {
            key: 'tooltipHeaderFormatter',
            value: function tooltipHeaderFormatter() {
                return d3.currentLocale.timeFormat.multi([['%d/%m/%Y %H:%M', function (d) {
                    return true;
                }]]);
            }
        }, {
            key: 'tooltipValueFormatter',
            value: function tooltipValueFormatter() {
                var self = this;

                return function (d, i, entry) {
                    var output = '-';

                    if (entry.axis === 1) {
                        if (!isNaN(d) && d !== null) {
                            // output = `${d3.format(',.2f')(d)}  ${self.form.modality.unit}`;
                            output = '' + d3.format(',.2f')(d);
                        }
                    } else if (entry.axis === 2) {
                        if (!isNaN(d)) {
                            output = self.alertLevels[d][self.alertDescription];
                        }
                    }

                    return output;
                };
            }
        }]);

        return MultiChartConfig;
    }();
})();